import { Injectable } from '@angular/core';
//import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class CustomDateTimeService {

  converToLocalTime(serverDate): Date {
    if (serverDate != null) {
      //console.log('serverDate-------------' + serverDate);
      var dt = new Date(Date.parse(serverDate));
      //console.log('dateStrbefore-------------' + dt);
      if (dt.getFullYear() > 1900) {
        var localDate = dt;

        var gmt = localDate;
        var min = gmt.getTime() / 1000 / 60; // convert gmt date to minutes
        var localNow = new Date().getTimezoneOffset(); // get the timezone
        // offset in minutes
        var localTime = min - localNow; // get the local time

        var dateStr = new Date(localTime * 1000 * 60);
        // dateStr = dateStr.toISOString("yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"); // this will return as just the server date format i.e., yyyy-MM-dd'T'HH:mm:ss.SSS'Z'
        //dateStr = dateStr.toString("yyyy-MM-dd'T'HH:mm:ss.SSS'Z'");

        //console.log('dateStr after-------------' + dateStr);
        //console.log('dateStr.toISOString-------------' + dateStr.toISOString());
        //console.log('dateStr.toISOString to date-------------' + new Date(dateStr.toISOString()));
        return dateStr;
      }
      else {
        return null;
      }
    }
    else {
      return null;
    }
  }
}
